import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function SuccessText({ message, mb }) {
  const classes = useStyles();
  let style = {};
  if (mb) {
    style.marginBottom = "1rem";
  }
  return (
    <div className={classes.root} style={style}>
      <Alert severity="success">{message}</Alert>
    </div>
  );
}
